import FetchApi from "../util/fetchApi";
const fetchApi = new FetchApi();

export default class CommonService {
  async getDefaultConfig() {
    return (await fetchApi.get(`/generalConfig`)).data;
  }
}
